const TableLoading = () => {
	const overlayStyles = {
		position: 'absolute' as const,
		inset: 0,
		borderRadius: '0.475rem',
		backgroundColor: 'rgba(17, 24, 39, 0.45)',
		backdropFilter: 'blur(2px)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 10,
	}
	const messageStyles = {
		borderRadius: '0.475rem',
		boxShadow: '0 0 40px 0 rgb(15 23 42 / 35%)',
		backgroundColor: '#fff',
		color: '#111827',
		fontWeight: '600',
		margin: '0',
		width: 'auto',
		padding: '0.85rem 1.75rem',
		display: 'inline-flex',
		alignItems: 'center',
		gap: '0.625rem',
	}

	return (
		<div style={overlayStyles} role='status' aria-live='polite' aria-label='Loading table data'>
			<div style={messageStyles}>
				<span className='spinner-border spinner-border-sm text-dark' aria-hidden='true' />
				Loading...
			</div>
		</div>
	)
}

export default TableLoading
